<template>
    <div class="login-page">
        <div class="modal" v-if="isShow">
            <div class="msg" :class="{'transparent':isTransparent}">
                <img src="../assets/images/login_remind@3x.png">
                <span>登录前请阅读并接受以上条款</span>
            </div>
        </div>
        <mt-header fixed title="登录" style="background:#ffffff;color:#262626;padding: 0 20px">
            <router-link to="/" slot="left">
                <mt-button>
                    <img src="../assets/images/login_close@3x.png" style="width: 16px;height: 16px">
                </mt-button>
            </router-link>
        </mt-header>

        <div class="main-section">
            <img class="logo" src="../assets/images/login_logo@3x.png">
            <div class="phone" @click="goLogin('phone')">
                <img src="../assets/images/login_phone@3x.png">
                手机号登录
            </div>
            <div class="agreement">
                <div @click="changeAgreeStatus()">
                    <img v-if="isAgreed" src="../assets/images/login_read_select@3x.png">
                    <img v-if="!isAgreed" src="../assets/images/login_read_normal@3x.png">
                    已阅读并同意以下协议：
                </div>
                <div>
                    <span @click="goArticle(null,'果师兄用户协议')">《果师兄用户协议》</span>
                    <span @click="goArticle(null,'隐私政策')">《隐私政策》</span>
                </div>
            </div>
            <div class="others">
                <div>其他登录方式</div>
                <div @click="qqLogin">
                    <img src="../assets/images/login_qq@3x.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            isAgreed: true,
            isShow: false,
            isTransparent: false,
            redirect_uri: "",
            nextPath: '',
            app_id: window.config.appid,
            entryButton: '',
            user_url: window.config.API_URL1+'/apph5/page/license?app_id='+window.config.appid,
            yinsi_url: window.config.API_URL1+'/apph5/page/privacy?app_id='+window.config.appid
        }
    },
    mounted(){

    },
    created(){
        this.nextPath = this.$route.query.path
        this.entryButton = this.$route.query.entryButton
        this.redirect_uri = "https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101852472&state=home&display=mobile&redirect_uri="+window.config.redirect_uri+"/bandMobile"
    },
    methods:{
        qqLogin(){
            this.sa_m_login(
                localStorage.kxuid,
                'QQ',
                this.entryButton
            )
            window.open(this.redirect_uri,'_self','')
        },
        goArticle(url,title){
            this.$router.push({name:"article",query:{url:url,title:title}})
        },
        changeAgreeStatus(){
            this.isAgreed = !this.isAgreed
        },
        goLogin(type){
            if(this.isAgreed){
                this.sa_m_login(
                    localStorage.kxuid,
                    '手机',
                    this.entryButton
                )
              const redirectUrl = this.$route.query.redirectUrl;
              this.$router.push({name:'phoneLogin',query:{path:this.nextPath, redirectUrl}})
            }else {
                this.isShow = true
                let that = this
                setTimeout(function(){
                    that.isTransparent = true
                    setTimeout(function(){
                        that.isShow = false
                        that.isTransparent = false
                    },100)
                },2000)
            }
        }
    },
    components:{
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue